import { useState } from 'react';
import { ChevronDownIcon } from './ChevronDown';
import { ChevronRightIcon } from './ChevronRight';
import { TertiaryGrid } from './TertiaryGrid';
import { InfoIcon } from './InfoIcon';

export const SecondaryGridRow = ({ row, rowIndex, numHeaders, onOpenModal }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasTertiaryGrid = row.tertiaryGrid && row.tertiaryGrid.rows.length > 0;
  const isCollapsible = hasTertiaryGrid && row.tertiaryGrid.isCollapsible !== false;
  const PAST_DUE_MESSAGE = "A sample from this group was missed during a previous compliance cycle. To be current with monitoring requirements, the water system must collect the required number of sample(s) during the period shown in the ‘Next Sample Due’ field and submit the results to DDW.";
  const REPEAT_SAMPLE_MESSAGE = "For repeat samples, sample upstream, downstream, and at the original site.";

  const toggleExpand = (e) => {
      // Prevent the modal from opening when toggling expand/collapse
      e.stopPropagation();
      if (isCollapsible) setIsExpanded(!isExpanded); 
  };

  const isEvenRow = rowIndex % 2 === 0;

  return (
    <>
      <div 
        onClick={toggleExpand}
        className={`grid-row secondary ${isEvenRow ? 'is-even' : 'is-odd'} ${hasTertiaryGrid ? 'clickable' : ''}`}
      >
        {/* Step 1: Render the data cells from the array */}
        {row.cells.map((cell, cellIndex) => (
          <div key={cellIndex} className={`grid-cell-secondary ${isEvenRow ? 'is-even' : 'is-odd'}`}>
            {cell}
            {cell === 'Past Due' && (<button onClick={(e) => onOpenModal(e, "Past Due Sample", PAST_DUE_MESSAGE)} className="info-icon-button"><InfoIcon /></button>)}
            {(cell === 'RP' || cell === 'Repeat') && <button onClick={(e) => onOpenModal(e, "Repeat Sample Information", REPEAT_SAMPLE_MESSAGE)} className="info-icon-button"><InfoIcon /></button>}
          </div>
        ))}

        {/* Step 2: Immediately after, render the final "Details" cell */}
        {numHeaders > row.cells.length && (<div className={`grid-cell-secondary ${isEvenRow ? 'is-even' : 'is-odd'}`}>
          {isCollapsible && (
            <div className="show-hide-row">
              <span className='show-hide'>{isExpanded ? 'Hide' : 'Show'}&nbsp;</span>
              {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            </div>
          )}
          {/* If there's no tertiary grid, this cell will be rendered empty,
              which correctly holds the column's place. */}
        </div>)}
      </div>

      {/* This part for the expanded grid container remains the same */}
      {isCollapsible && (
        <div style={{ gridColumn: '1 / -1' }}>
            <div className={`expandable-content ${isExpanded ? 'expanded' : ''}`}>
              <div className={`grid-container-tertiary ${isEvenRow ? 'is-even' : 'is-odd'}`}>
                <TertiaryGrid 
                  headers={row.tertiaryGrid.headers} 
                  rows={row.tertiaryGrid.rows} 
                  onOpenModal={onOpenModal}
                />
              </div>
            </div>
        </div>
      )}
    </>
  );
};